const runtimeBaseUrl = typeof window !== 'undefined' && window.__API_BASE_URL__
  ? window.__API_BASE_URL__
  : undefined;

export const API_BASE_URL = runtimeBaseUrl
  || process.env.REACT_APP_API_URL
  || 'https://erp.atmturkiye.com/api';

export default {
  API_BASE_URL,
};